import { PRICING_PLANS } from '@wix/app-definition-ids';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { assertNotOptional } from '@wix/seo-common-core';
import { useAtomValue } from 'jotai';
import { useCallback, useMemo } from 'react';
import { updatePricingPlansAltText } from '../../../api/new-infra-updates/update-pricing-plans-alt-text';
import { altTextScreenPageIdAtom } from '../../../atoms/session-atoms';
import { useImageElementsOrder } from '../alt-text/use-image-elements-order';
export const usePricingPlansAltTextHandlers = () => {
  const {
    getOrderedImageElements
  } = useImageElementsOrder();
  const altTextScreenPageId = useAtomValue(altTextScreenPageIdAtom);
  assertNotOptional(altTextScreenPageId);
  const errorHandler = useErrorHandler();
  const httpClient = useHttpClient();
  const openImageElement =
  // pricing-plan has only one page thus we dont need to add sausage support
  useCallback(() => {}, []);
  const getEntityName =
  // pricing plan will not have innerRoute object and all its image will be at the same page
  useCallback(() => {
    return '';
  }, []);
  const getElementOrder = useCallback(altImageRuleProps => getOrderedImageElements(altImageRuleProps), [getOrderedImageElements]);
  const enabledDecorativeImages = false;
  const appDefinitionId = PRICING_PLANS;
  const setBulkAltText = useCallback(async bulkAltTextData => {
    const response = await updatePricingPlansAltText(httpClient, errorHandler, bulkAltTextData);
    if (response.success === false) {
      throw new Error(response.errorMessage);
    }
  }, [errorHandler, httpClient]);
  return useMemo(() => ({
    appDefinitionId,
    enabledDecorativeImages,
    getElementOrder,
    getEntityName,
    openImageElement,
    setBulkAltText
  }), [appDefinitionId, getElementOrder, enabledDecorativeImages, getEntityName, openImageElement, setBulkAltText]);
};
//# sourceMappingURL=use-pricing-plans-alt-text-handlers.js.map